(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'react', '../styles/colors', '../styles/fonts/fonts'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('../styles/colors'), require('../styles/fonts/fonts'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.colors, global.fonts);
    global.CallUs = mod.exports;
  }
})(this, function (exports, _react, _colors, _fonts) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var CallUs = function CallUs() {
    return _react2.default.createElement(
      'p',
      {
        style: {
          fontFamily: _fonts.ProximaNova,
          color: _colors.prussian,
          fontSize: '16px',
          textAlign: 'right',
          letterSpacing: 'normal',
          position: 'relative',
          marginTop: '1rem',
          marginRight: '1rem'
        }
      },
      'Questions? Call 555-555-5555'
    );
  };

  exports.default = CallUs;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/elements/CallUs.js
// module id = 517
// module chunks = 0